import React from 'react'
import '../assets/styles/index.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import FizzBuzz from './challenges/FizzBuzz';
import FirstNonRepeatingChar from "./challenges/FirstNonRepeatingChar";
import Home from "./Home";
import FixGrouping from "./challenges/FixGrouping";
import LongestIncreasingSubsequence from "./challenges/LongestIncreasingSubsequence";
import PalindromeChecker from "./challenges/PalindromeChecker";
import RemoveDuplicates from "./challenges/RemoveDuplicates";
import PowerOfTwo from "./challenges/PowerOfTwo";
import MoveZeros from "./challenges/MoveZeroes";

function App() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/fizzbuzz" element={<FizzBuzz />} />
                <Route path="/firstnonrepeatingchar" element={<FirstNonRepeatingChar />} />
                <Route path="/fixgroup" element={<FixGrouping />} />
                <Route path="/longestincresingstring" element={<LongestIncreasingSubsequence />} />
                <Route path="/palindrome" element={<PalindromeChecker />} />
                <Route path="/duplicates" element={<RemoveDuplicates />} />
                <Route path="/zweierpotenz" element={<PowerOfTwo />} />
                <Route path="/movezeros" element={<MoveZeros />} />
                <Route path="/map" element={<Navigate to="/ccx-map.html" replace />} />
            </Routes>
        </>
    );
}

export default App;
